import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Mail, Phone, MessageCircle } from 'lucide-react';
import { mockData } from '../../mock';

const ContactSection = ({ formData, setFormData, handleSubmit, isSubmitting }) => {
  return (
    <section id="contact" className="py-20 px-6 bg-[#111111]">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Get Your Free Website Preview</h2>
          <p className="text-[#9AA3B2] text-lg mb-6">
            Let's discuss your project. I'll reply within 24 hours.
          </p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center items-center text-[#9AA3B2]">
            <a href={`mailto:${mockData.contact.email}`} className="hover:text-[#2F6BFF] transition-colors flex items-center gap-2">
              <Mail className="h-4 w-4" />
              {mockData.contact.email}
            </a>
            <span className="hidden sm:inline">•</span>
            <a href={`tel:${mockData.contact.phone}`} className="hover:text-[#2F6BFF] transition-colors flex items-center gap-2">
              <Phone className="h-4 w-4" />
              {mockData.contact.phoneDisplay}
            </a>
          </div>
        </div>
        <Card className="bg-[#1a1a1a] border-gray-800">
          <CardContent className="pt-6">
            <p className="text-center text-sm text-[#9AA3B2] mb-6">No commitment required.</p>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-2 text-[#F5F7FF]">Your Name</label>
                <Input 
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  placeholder="John Smith"
                  required
                  className="bg-[#0a0a0a] border-gray-700 text-[#F5F7FF]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-[#F5F7FF]">Email Address</label>
                <Input 
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  placeholder="john@example.com"
                  required
                  className="bg-[#0a0a0a] border-gray-700 text-[#F5F7FF]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-[#F5F7FF]">Business Name</label>
                <Input 
                  value={formData.business}
                  onChange={(e) => setFormData({...formData, business: e.target.value})}
                  placeholder="Your Business Name"
                  required
                  className="bg-[#0a0a0a] border-gray-700 text-[#F5F7FF]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-[#F5F7FF]">Tell me about your project</label>
                <Textarea 
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  placeholder="What kind of website do you need?"
                  rows={5}
                  required
                  className="bg-[#0a0a0a] border-gray-700 text-[#F5F7FF]"
                />
              </div>
              <Button 
                type="submit"
                size="lg"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] hover:bg-gradient-to-r hover:from-[#4DA3FF] hover:to-[#2F6BFF] text-white text-lg py-6 hover:scale-105 transition-all duration-200"
              >
                <MessageCircle className="mr-2 h-5 w-5" />
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </Button>
            </form>
          </CardContent>
        </Card>
        
        {/* Trust badges */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {['Mobile Responsive', 'Fast Loading', 'SEO Ready', 'UK Based'].map((badge, index) => (
            <div 
              key={index}
              className="flex items-center justify-center gap-2 px-4 py-3 bg-[#1a1a1a] rounded-lg border border-[#2F6BFF]/20"
            >
              <span className="text-[#4DA3FF] text-lg">✓</span>
              <span className="text-sm text-[#F5F7FF] font-medium whitespace-nowrap">{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
